const patterns = (state = [], action) => {
	switch (action.type) {
		case "CREATE_DARK_PATTERN2D":
			return Object.assign([], state, [...state, action.patternConfig]);

		default:
			return state;
	}
};

export default patterns;



// WEBPACK FOOTER //
// ./src/reducers/patterns2d.js